module.exports = __webpack_public_path__ + "img/2_heart.64f78fc4.jpg";